module.exports = __webpack_public_path__ + "static/media/telegram.a9985056.svg";